export enum Suit {
  Blue = "blue",
  Yellow = "yellow",
  Pink = "pink",
  Green = "green",
  Rockets = "rockets"
}

export class SuitedNumber {
  constructor(public suit: Suit, public number: number) {}
}

export enum Hint {
  Highest = "highest",
  Lowest = "lowest",
  Only = "only",
  None = ""
}

export class HintedSuitedNumber {
  constructor(public suitedNumber: SuitedNumber, public hint: Hint) {}
}

export class Goal {
  constructor(public suitedNumber: SuitedNumber) {}
}
